import styled from 'styled-components';
import colors from '../../assets/styles/colors';

export const ClientRegistrationContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 44px 20px 15px 20px;
  background: ${colors.bgGray};
`;

export const ClientRegistrationWrapper = styled.div`
  margin-bottom: 30px;
`;

export const ClientRegistrationContent = styled.div`
  margin-top: 40px;
  display: grid;
  grid-template-columns: ${prop => prop.showSteps ? '260px 1fr' : '1fr'};
`;

export const ClientRegistrationHeader = styled.div`

`;

export const ClientRegistrationHeaderArea = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ClientRegistrationHeaderTitle = styled.small`
  font-size: 12px;
  color: ${colors.textSecondary};
`;
